import React, { useState } from 'react';
import './pricing.css';
import { FaCircleCheck } from "react-icons/fa6";

const Pricing = () => {
  // State pour le plan sélectionné
  const [selectedPlan, setSelectedPlan] = useState(null);

  // State pour basculer entre Monthly et Annually
  const [isAnnual, setIsAnnual] = useState(false);

  // Prix pour chaque plan (Mensuel et Annuel)
  const prices = {
    standart: isAnnual ? 50 : 5,  // 50 fcfa Annuel, 5 fcfa Mensuel
    extended: isAnnual ? 120 : 12,
    premium: isAnnual ? 160 : 16,
  };

  // Données des plans
  const plans = [
    {
      name: 'Standart',
      price: prices.standart,
      features: [
        '5 collections',
        'Worldwide accessibility',
        '25 automation actions',
        'Access all features',
        '24 hours support',
        'Sync across devices',
        'Share with more 5 users'
      ],
      disabledFeatures: 2
    },
    {
      name: 'Extended',
      price: prices.extended,
      features: [
        'Unlimited collections',
        'Worldwide accessibility',
        'Unlimited automation actions',
        'Access all features',
        '24 hours support',
        'Sync across devices',
        'Share with more 10 users'
      ]
    },
    {
      name: 'Premium+',
      price: prices.premium,
      features: [
        'Unlimited collections',
        'Worldwide accessibility',
        'Unlimited automation actions',
        'Access all features',
        '24 hours support',
        'Sync across devices',
        'Share with more 10 users'
      ]
    }
  ];

  // Fonction pour gérer la sélection du plan
  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
  };


  return (
    <div className="marjolaine ">
      <div className="sieux container text-center ">
        <h2 className="text-warning fw-bold mb-4 ">Our pricing</h2>
        <p className="text-muted mb-4">
          Pay securely online and manage the booking via desktop or via the mobile app.
        </p>

        <div className="pricing-container">
      <span className={`pricing-label ${!isAnnual ? 'active' : ''}`}>
        Monthly
      </span>
      
      <button
        className={`pricing-switch ${isAnnual ? 'active' : ''}`}
        role="switch"
        aria-checked={isAnnual}
        onClick={() => setIsAnnual(!isAnnual)}
      >
        <span className="pricing-slider" />
      </button>

      <span className={`pricing-label ${isAnnual ? 'active' : ''}`}>
        Annually
      </span>
        </div>

        <div className="pricing-grid">
          {plans.map((plan, index) => {
            const isSelected = selectedPlan === plan.name.toLowerCase();
            const isExtended = plan.name === 'Extended';

            return (
              <div 
                className={`pricing-card ${isSelected ? 'pricing-card--selected' : ''} 
                          ${isExtended ? 'pricing-card--extended' : ''}`}
                key={plan.name}
              >
                <h3 className="pricing-card__title">{plan.name}</h3>
                <p className="pricing-card__description">
                  The national average cost of buying coin easy.
                </p>
                <div className="pricing-card__price">
                  <span className="price-amount">{plan.price}</span>
                  <span className="price-period">/month</span>
                </div>
                <button
                  className={`pricing-card__button ${isExtended ? 'pricing-card__button--orange' : ''}`}
                  onClick={() => handleSelectPlan(plan.name.toLowerCase())}
                >
                  Select Plan
                </button>
                <ul className="pricing-card__features">
                  {plan.features.map((feature, featureIndex) => (
                    <li 
                      key={featureIndex}
                      className={`pricing-card__feature 
                        ${featureIndex >= plan.features.length - (plan.disabledFeatures || 0) 
                          ? 'pricing-card__feature--disabled' 
                          : ''}`}
                    >
                      <FaCircleCheck className="feature-icon" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Pricing;
